import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCaseDocuments,
  createCaseDocument,
  updateCaseDocument,
  deleteCaseDocument,
  createBulkCaseDocumentAction,
} from "../../actions/cd_caseDocs/cd_caseDocsAction";

const initialState = {
  documents: [],
  loading: false,
  error: null,
  lastFetched: null,
};

const cd_caseDocsSlice = createSlice({
  name: "cd_caseDocs",
  initialState,
  reducers: {
    clearDocumentsState: () => initialState,
  },
  extraReducers: (builder) => {
    // FETCH
    builder
      .addCase(fetchCaseDocuments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCaseDocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.documents = action.payload;
        state.lastFetched = new Date().toISOString();
      })
      .addCase(fetchCaseDocuments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // CREATE
      .addCase(createCaseDocument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCaseDocument.fulfilled, (state, action) => {
        if (action.payload?.document) {
          state.documents.unshift(action.payload.document);
        }
      })
      .addCase(createCaseDocument.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // UPDATE
      .addCase(updateCaseDocument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCaseDocument.fulfilled, (state, action) => {
        const updatedDoc = action.payload?.document;
        if (updatedDoc) {
          const index = state.documents.findIndex(
            (d) => d.caseDocId === updatedDoc.caseDocId,
          );
          if (index !== -1) {
            state.documents[index] = {
              ...state.documents[index],
              ...updatedDoc,
            };
          }
        }
      })
      .addCase(updateCaseDocument.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // DELETE

      .addCase(deleteCaseDocument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCaseDocument.fulfilled, (state, action) => {
        state.documents = state.documents.filter(
          (d) => d.caseDocId !== action.payload,
        );
      })
      .addCase(deleteCaseDocument.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        })

      // BULK CREATE

      .addCase(createBulkCaseDocumentAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createBulkCaseDocumentAction.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(action.payload?.documents)) {
          state.documents = [...action.payload.documents, ...state.documents];
        }
      })
      .addCase(createBulkCaseDocumentAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDocumentsState } = cd_caseDocsSlice.actions;
export default cd_caseDocsSlice.reducer;
